import { render, staticRenderFns } from "./PollingEventChoicesPage.vue?vue&type=template&id=2628609e&scoped=true&"
import script from "./PollingEventChoicesPage.vue?vue&type=script&lang=js&"
export * from "./PollingEventChoicesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2628609e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/bikrampahi/Projects/upwork/5 Brian/sndle.io/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VApp,VContainer,VDataTable,VIcon,VProgressLinear})
